import Joi from 'joi';


export const VALIDATION_MEMBERSHIP_CREATE = {
  options: {allowUnknownBody: false},
  body: {
    name: Joi.string().required(),
    features: Joi.string().required(),
    price: Joi.number().required(),
    unitPrice: Joi.string().valid('VND').required(),
  }
};


export const VALIDATION_MEMBERSHIP_DELETE = {
  options: {allowUnknownBody: false},
  body: {
    id: Joi.string().required(),
  }
};


export const VALIDATION_MEMBERSHIP_LIST = {
  options: {allowUnknownBody: false},
  body: {
  }
};



// WEBPACK FOOTER //
// ./src/services/membership/Membership.Validator.js